import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultPlaceholder: {
		id: 'issue-picker.default-placeholder',
		defaultMessage: 'Search by issue key or summary',
		description: 'Placeholder for the user input in the issue picker',
	},
	defaultRecentIssues: {
		id: 'issue-picker.default-recent-issues',
		defaultMessage: 'Recent Issues',
		description: 'Group heading for the recent search results',
	},
	defaultMatchingIssues: {
		id: 'issue-picker.default-matching-issues',
		defaultMessage: 'Matching Issues',
		description: 'Group heading for the recent search results',
	},
	defaultFailedLoadingIssues: {
		id: 'issue-picker.default-failed-loading-issues',
		defaultMessage: 'Failed to load issues',
		description: 'Message when there is a connectivity failure',
	},
	createIssue: {
		id: 'issue-picker.create-issue',
		defaultMessage: 'Create an issue for {value}',
		description: 'label for creating a new issue with specified value',
	},
	defaultPlaceholderIssueTerminologyRefreshM4: {
		id: 'issue-picker.default-placeholder-issue-terminology-refresh-m4',
		defaultMessage: 'Search by work item key or summary',
		description: 'Placeholder for the user input in the issue picker',
	},
	defaultRecentIssuesIssueTerminologyRefreshM4: {
		id: 'issue-picker.default-recent-issues-issue-terminology-refresh-m4',
		defaultMessage: 'Recent work items',
		description: 'Group heading for the recent search results',
	},
	defaultMatchingIssuesIssueTerminologyRefreshM4: {
		id: 'issue-picker.default-matching-issues-issue-terminology-refresh-m4',
		defaultMessage: 'Matching work items',
		description: 'Group heading for the recent search results',
	},
	defaultFailedLoadingIssuesIssueTerminologyRefreshM4: {
		id: 'issue-picker.default-failed-loading-issues-issue-terminology-refresh-m4',
		defaultMessage: 'Failed to load work items',
		description: 'Message when there is a connectivity failure',
	},
	createIssueIssueTerminologyRefreshM4: {
		id: 'issue-picker.create-issue-issue-terminology-refresh-m4',
		defaultMessage: 'Create a work item for {value}',
		description: 'label for creating a new issue with specified value',
	},
});
